// extracted by mini-css-extract-plugin
module.exports = {"mainColor":"#344E41","cardmaker":"cardmaker_cardmaker__1G9Ld","title":"cardmaker_title__3Z0JP","forms":"cardmaker_forms__EYB_W"};